/** HanaroAPI public v1 types — trimmed for invoice processing. */

export type HanaroStoreRef = {
  storeID?: string | null;
  storeName?: string | null;
  displayName?: string | null;
};

export type GetProductSnapshotPricingRequest = {
  stores?: HanaroStoreRef[] | null;
  pageIndex?: number;
  pageSize?: number;
};

export type PaginatedInventoryResponse<T> = {
  totalRecords?: number;
  pageIndex?: number;
  pageSize?: number;
  totalPages?: number;
  items?: T[] | null;
};

export type ProductSnapshotPricingStoreRow = {
  storeId?: number;
  sku?: string | null;
  storeName?: string | null;
  displayName?: string | null;
  supplierName?: string | null;
};

export type ProductSnapshotPricingItem = {
  productKey?: string | null;
  sku?: string | null;
  barcode?: string | null;
  orderCode?: string | null;
  description?: string | null;
  department?: string | null;
  subDepartment?: string | null;
  storeRows?: ProductSnapshotPricingStoreRow[] | null;
};

export type GetProductSnapshotPricingResponse =
  PaginatedInventoryResponse<ProductSnapshotPricingItem>;

export type HanaroStore = {
  storeID?: string | null;
  storeName?: string | null;
  displayName?: string | null;
  id?: string;
  name?: string | null;
  code?: string | null;
  isActive?: boolean;
  system?: string | null;
};

export function storeCatalogKey(s: HanaroStore): string {
  const k = s.storeID ?? s.id;
  return k != null && String(k).length > 0 ? String(k) : "";
}

export function storeDisplayName(s: HanaroStore): string {
  return (s.displayName ?? s.storeName ?? s.name ?? storeCatalogKey(s)).trim();
}
